export type LocationType =
  | "airport"
  | "city"
  | "resort"
  | "destination";

export type LocationData = {
  id: string;
  type: LocationType;

  nearbyLocationIds: string[];

  highlights: string[];
  popularAreas: string[];
  hotels: string[];
  beaches: string[];
};

export const locations: Record<string, LocationData> = {
  "faro-airport": {
    id: "faro-airport",
    type: "airport",

    nearbyLocationIds: [
      "faro",
      "olhao",
      "almancil",
      "quinta-do-lago",
      "vale-do-lobo",
    ],

    highlights: [
      "arrivals-terminal",
      "departures-terminal",
      "airport-meeting-point",
    ],

    popularAreas: [
      "terminal-building",
      "arrivals-hall",
      "departures-area",
    ],

    hotels: [],

    beaches: [],
  },

  faro: {
    id: "faro",
    type: "city",

    nearbyLocationIds: [
      "faro-airport",
      "olhao",
      "almancil",
      "quinta-do-lago",
      "vale-do-lobo",
    ],

    highlights: [
      "old-town",
      "faro-marina",
      "ria-formosa",
      "faro-cathedral",
    ],

    popularAreas: [
      "old-town",
      "city-centre",
      "marina",
      "montenegro",
    ],

    hotels: [
      "hotel-faro-and-beach-club",
      "ap-eva-senses",
      "3hb-faro",
    ],

    beaches: [
      "praia-de-faro",
      "ilha-deserta",
    ],
  },

  albufeira: {
    id: "albufeira",
    type: "destination",

    nearbyLocationIds: [
      "vilamoura",
      "armacao-de-pera",
      "carvoeiro",
      "portimao",
      "lagos",
    ],

    highlights: [
      "old-town",
      "praia-dos-pescadores",
      "albufeira-marina",
      "the-strip",
    ],

    popularAreas: [
      "old-town",
      "oura",
      "gale",
      "olhos-de-agua",
      "sao-rafael",
      "sesmarias",
    ],

    hotels: [
      "pine-cliffs-resort",
      "w-algarve",
      "epic-sana-algarve",
      "nau-salgados-palace",
    ],

    beaches: [
      "praia-dos-pescadores",
      "praia-da-oura",
      "praia-da-gale",
      "praia-de-sao-rafael",
    ],
  },

  vilamoura: {
    id: "vilamoura",
    type: "resort",

    nearbyLocationIds: [
      "quarteira",
      "vale-do-lobo",
      "quinta-do-lago",
      "albufeira",
      "almancil",
    ],

    highlights: [
      "vilamoura-marina",
      "praia-da-falesia",
      "golf-courses",
      "casino-vilamoura",
    ],

    popularAreas: [
      "vilamoura-marina",
      "old-village",
      "victoria-golf",
      "praia-da-falesia",
    ],

    hotels: [
      "domes-lake-algarve",
      "tivoli-marina-vilamoura",
      "anantara-vilamoura",
      "crowne-plaza-vilamoura",
    ],

    beaches: [
      "praia-de-vilamoura",
      "praia-da-falesia",
    ],
  },

  quarteira: {
    id: "quarteira",
    type: "city",

    nearbyLocationIds: [
      "vilamoura",
      "vale-do-lobo",
      "quinta-do-lago",
      "almancil",
      "albufeira",
    ],

    highlights: [
      "quarteira-promenade",
      "fish-market",
      "marina-area",
      "local-restaurants",
    ],

    popularAreas: [
      "city-centre",
      "promenade",
      "beachfront",
    ],

    hotels: [
      "aquashow-park-hotel",
      "dom-jose-beach-hotel",
    ],

    beaches: [
      "praia-de-quarteira",
      "praia-do-forte-novo",
    ],
  },

  loule: {
    id: "loule",
    type: "city",

    nearbyLocationIds: [
      "almancil",
      "vilamoura",
      "quarteira",
      "faro",
      "sao-bras-de-alportel",
    ],

    highlights: [
      "loule-market",
      "loule-castle",
      "historic-centre",
      "local-crafts",
    ],

    popularAreas: [
      "historic-centre",
      "market-area",
      "city-centre",
    ],

    hotels: [
      "loule-jardim-hotel",
    ],

    beaches: [],
  },

  almancil: {
    id: "almancil",
    type: "city",

    nearbyLocationIds: [
      "quinta-do-lago",
      "vale-do-lobo",
      "vilamoura",
      "quarteira",
      "faro",
    ],

    highlights: [
      "sao-lourenco-church",
      "restaurants",
      "golf-access",
      "luxury-resorts",
    ],

    popularAreas: [
      "town-centre",
      "quinta-do-lago-access",
      "vale-do-lobo-access",
    ],

    hotels: [
      "conrad-algarve",
      "vilar-do-golf",
    ],

    beaches: [],
  },

  "quinta-do-lago": {
    id: "quinta-do-lago",
    type: "resort",

    nearbyLocationIds: [
      "vale-do-lobo",
      "almancil",
      "vilamoura",
      "faro",
      "faro-airport",
    ],

    highlights: [
      "championship-golf-courses",
      "ria-formosa",
      "the-campus",
      "quinta-do-lago-beach",
    ],

    popularAreas: [
      "quinta-do-lago-resort",
      "the-campus",
      "laranjal-golf",
      "beach-area",
    ],

    hotels: [
      "conrad-algarve",
      "hotel-quinta-do-lago",
      "magnolia-hotel",
    ],

    beaches: [
      "quinta-do-lago-beach",
      "ancao-beach",
    ],
  },

  "vale-do-lobo": {
    id: "vale-do-lobo",
    type: "resort",

    nearbyLocationIds: [
      "quinta-do-lago",
      "almancil",
      "vilamoura",
      "quarteira",
      "faro-airport",
    ],

    highlights: [
      "royal-golf-course",
      "ocean-golf-course",
      "vale-do-lobo-beach",
      "the-praca",
    ],

    popularAreas: [
      "vale-do-lobo-resort",
      "the-praca",
      "royal-golf",
      "ocean-golf",
    ],

    hotels: [
      "dona-filipa-hotel",
      "vale-do-lobo-resort",
      "ria-park-hotel",
    ],

    beaches: [
      "vale-do-lobo-beach",
      "garrao-beach",
    ],
  },

  olhao: {
    id: "olhao",
    type: "city",

    nearbyLocationIds: [
      "faro",
      "faro-airport",
      "fuzeta",
      "moncarapacho",
      "tavira",
    ],

    highlights: [
      "olhao-market",
      "ria-formosa",
      "historic-centre",
      "island-boat-trips",
    ],

    popularAreas: [
      "waterfront",
      "market-area",
      "historic-centre",
      "marina",
    ],

    hotels: [
      "real-marina-hotel-and-spa",
      "pure-formosa-concept-hotel",
    ],

    beaches: [
      "ilha-da-armona",
      "ilha-da-culatra",
      "ilha-do-farol",
    ],
  },

  tavira: {
    id: "tavira",
    type: "city",

    nearbyLocationIds: [
      "cabanas-de-tavira",
      "santa-luzia",
      "monte-gordo",
      "olhao",
      "faro",
    ],

    highlights: [
      "tavira-castle",
      "roman-bridge",
      "tavira-island",
      "ria-formosa",
    ],

    popularAreas: [
      "historic-centre",
      "riverfront",
      "santa-luzia",
      "cabanas-de-tavira",
    ],

    hotels: [
      "pousada-convento-de-tavira",
      "ozadi-tavira-hotel",
      "ap-cabanas-beach-and-nature",
    ],

    beaches: [
      "tavira-island",
      "barril-beach",
      "cabanas-beach",
    ],
  },

  "cabanas-de-tavira": {
    id: "cabanas-de-tavira",
    type: "destination",

    nearbyLocationIds: [
      "tavira",
      "santa-luzia",
      "monte-gordo",
      "cacela-velha",
      "faro",
    ],

    highlights: [
      "cabanas-boardwalk",
      "ria-formosa",
      "boat-crossing",
      "local-restaurants",
    ],

    popularAreas: [
      "waterfront",
      "village-centre",
      "beach-access",
    ],

    hotels: [
      "ap-cabanas-beach-and-nature",
      "pedras-da-rainha",
    ],

    beaches: [
      "cabanas-beach",
    ],
  },

  "monte-gordo": {
    id: "monte-gordo",
    type: "destination",

    nearbyLocationIds: [
      "vila-real-de-santo-antonio",
      "castro-marim",
      "altura",
      "manta-rota",
      "tavira",
    ],

    highlights: [
      "monte-gordo-beach",
      "casino",
      "promenade",
      "restaurants",
    ],

    popularAreas: [
      "beachfront",
      "town-centre",
      "casino-area",
    ],

    hotels: [
      "the-prime-energize",
      "vasco-da-gama-hotel",
      "monte-gordo-hotel-apartments",
    ],

    beaches: [
      "monte-gordo-beach",
    ],
  },

  "vila-real-de-santo-antonio": {
    id: "vila-real-de-santo-antonio",
    type: "city",

    nearbyLocationIds: [
      "monte-gordo",
      "castro-marim",
      "ayamonte",
      "altura",
      "manta-rota",
    ],

    highlights: [
      "marques-de-pombal-square",
      "guadiana-river",
      "historic-centre",
      "spain-ferry",
    ],

    popularAreas: [
      "historic-centre",
      "riverfront",
      "marina",
    ],

    hotels: [
      "grand-house-algarve",
      "pousada-vila-real-de-santo-antonio",
    ],

    beaches: [
      "santo-antonio-beach",
    ],
  },

  "armacao-de-pera": {
    id: "armacao-de-pera",
    type: "destination",

    nearbyLocationIds: [
      "porches",
      "albufeira",
      "carvoeiro",
      "lagoa",
      "silves",
    ],

    highlights: [
      "armacao-de-pera-beach",
      "seafront-promenade",
      "fishermens-area",
      "nearby-coves",
    ],

    popularAreas: [
      "town-centre",
      "seafront",
      "beach-area",
    ],

    hotels: [
      "vilalara-grand-hotel-algarve",
      "holiday-inn-algarve",
    ],

    beaches: [
      "armacao-de-pera-beach",
      "senhora-da-rocha-beach",
    ],
  },

  porches: {
    id: "porches",
    type: "destination",

    nearbyLocationIds: [
      "armacao-de-pera",
      "carvoeiro",
      "lagoa",
      "albufeira",
      "silves",
    ],

    highlights: [
      "traditional-pottery",
      "senhora-da-rocha",
      "coastal-cliffs",
      "local-wineries",
    ],

    popularAreas: [
      "village-centre",
      "coastal-area",
      "senhora-da-rocha",
    ],

    hotels: [
      "vilalara-grand-hotel-algarve",
      "vila-vita-parc",
    ],

    beaches: [
      "senhora-da-rocha-beach",
      "cova-redonda-beach",
    ],
  },

  lagoa: {
    id: "lagoa",
    type: "city",

    nearbyLocationIds: [
      "carvoeiro",
      "porches",
      "ferragudo",
      "portimao",
      "silves",
    ],

    highlights: [
      "historic-centre",
      "wine-region",
      "fatacil",
      "nearby-beaches",
    ],

    popularAreas: [
      "city-centre",
      "industrial-area",
      "coastal-access",
    ],

    hotels: [
      "lagoa-hotel",
    ],

    beaches: [],
  },

  carvoeiro: {
    id: "carvoeiro",
    type: "destination",

    nearbyLocationIds: [
      "lagoa",
      "ferragudo",
      "portimao",
      "armacao-de-pera",
      "albufeira",
    ],

    highlights: [
      "carvoeiro-beach",
      "algar-seco",
      "benagil-cave",
      "coastal-walks",
    ],

    popularAreas: [
      "carvoeiro-centre",
      "vale-centeanes",
      "benagil",
      "sesmarias",
    ],

    hotels: [
      "tivoli-carvoeiro",
      "vale-doliveiras",
      "monte-santo-resort",
    ],

    beaches: [
      "carvoeiro-beach",
      "vale-centeanes-beach",
      "benagil-beach",
    ],
  },

  ferragudo: {
    id: "ferragudo",
    type: "destination",

    nearbyLocationIds: [
      "portimao",
      "praia-da-rocha",
      "carvoeiro",
      "lagoa",
      "alvor",
    ],

    highlights: [
      "fishing-village",
      "riverfront",
      "sao-joao-do-arade-castle",
      "local-restaurants",
    ],

    popularAreas: [
      "village-centre",
      "riverfront",
      "beach-area",
    ],

    hotels: [
      "caneiros-luxury-house-and-suites",
    ],

    beaches: [
      "praia-grande",
      "caneiros-beach",
    ],
  },

  portimao: {
    id: "portimao",
    type: "city",

    nearbyLocationIds: [
      "praia-da-rocha",
      "alvor",
      "ferragudo",
      "carvoeiro",
      "lagos",
    ],

    highlights: [
      "praia-da-rocha",
      "portimao-marina",
      "riverside-area",
      "shopping-and-restaurants",
    ],

    popularAreas: [
      "city-centre",
      "praia-da-rocha",
      "marina",
      "vau",
    ],

    hotels: [
      "jupiter-algarve-hotel",
      "rr-hotel-da-rocha",
      "algarve-race-resort",
    ],

    beaches: [
      "praia-da-rocha",
      "praia-do-vau",
      "praia-dos-tres-castelos",
    ],
  },

  "praia-da-rocha": {
    id: "praia-da-rocha",
    type: "destination",

    nearbyLocationIds: [
      "portimao",
      "alvor",
      "ferragudo",
      "carvoeiro",
      "lagos",
    ],

    highlights: [
      "praia-da-rocha-beach",
      "fort-of-santa-catarina",
      "marina",
      "nightlife",
    ],

    popularAreas: [
      "beachfront",
      "avenida-tomas-cabreira",
      "marina-area",
    ],

    hotels: [
      "rr-hotel-da-rocha",
      "jupiter-algarve-hotel",
      "tivoli-marina-portimao",
    ],

    beaches: [
      "praia-da-rocha",
      "praia-dos-tres-castelos",
    ],
  },

  alvor: {
    id: "alvor",
    type: "destination",

    nearbyLocationIds: [
      "portimao",
      "praia-da-rocha",
      "lagos",
      "ferragudo",
      "carvoeiro",
    ],

    highlights: [
      "alvor-boardwalk",
      "old-town",
      "ria-de-alvor",
      "alvor-beach",
    ],

    popularAreas: [
      "village-centre",
      "riverfront",
      "beach-area",
    ],

    hotels: [
      "pestana-alvor-praia",
      "tivoli-alvor-algarve-resort",
      "pestana-blue-alvor-beach",
    ],

    beaches: [
      "alvor-beach",
      "tres-irmaos-beach",
    ],
  },

  lagos: {
    id: "lagos",
    type: "city",

    nearbyLocationIds: [
      "praia-da-luz",
      "burgau",
      "alvor",
      "portimao",
      "sagres",
    ],

    highlights: [
      "lagos-old-town",
      "ponta-da-piedade",
      "praia-dona-ana",
      "lagos-marina",
    ],

    popularAreas: [
      "old-town",
      "marina",
      "meia-praia",
      "porto-de-mos",
    ],

    hotels: [
      "cascade-wellness-resort",
      "iberostar-selection-lagos",
      "tivoli-lagos",
    ],

    beaches: [
      "praia-dona-ana",
      "camilo-beach",
      "meia-praia",
      "porto-de-mos-beach",
    ],
  },

  "praia-da-luz": {
    id: "praia-da-luz",
    type: "destination",

    nearbyLocationIds: [
      "lagos",
      "burgau",
      "salema",
      "sagres",
      "alvor",
    ],

    highlights: [
      "praia-da-luz-beach",
      "seafront-promenade",
      "black-rock",
      "restaurants",
    ],

    popularAreas: [
      "village-centre",
      "beachfront",
      "promenade",
    ],

    hotels: [
      "belavista-da-luz",
      "baia-da-luz",
    ],

    beaches: [
      "praia-da-luz-beach",
    ],
  },

  burgau: {
    id: "burgau",
    type: "destination",

    nearbyLocationIds: [
      "praia-da-luz",
      "lagos",
      "salema",
      "sagres",
      "vila-do-bispo",
    ],

    highlights: [
      "fishing-village",
      "burgau-beach",
      "narrow-streets",
      "coastal-walks",
    ],

    popularAreas: [
      "village-centre",
      "beach-area",
      "clifftop",
    ],

    hotels: [
      "hotel-burgau-turismo-de-natureza",
    ],

    beaches: [
      "burgau-beach",
    ],
  },

  salema: {
    id: "salema",
    type: "destination",

    nearbyLocationIds: [
      "burgau",
      "praia-da-luz",
      "sagres",
      "vila-do-bispo",
      "lagos",
    ],

    highlights: [
      "salema-beach",
      "fishing-village",
      "dinosaur-footprints",
      "coastal-scenery",
    ],

    popularAreas: [
      "village-centre",
      "beachfront",
    ],

    hotels: [
      "nau-salema-beach-village",
    ],

    beaches: [
      "salema-beach",
    ],
  },

  sagres: {
    id: "sagres",
    type: "destination",

    nearbyLocationIds: [
      "vila-do-bispo",
      "salema",
      "burgau",
      "praia-da-luz",
      "lagos",
    ],

    highlights: [
      "sagres-fortress",
      "cape-saint-vincent",
      "surf-beaches",
      "dramatic-cliffs",
    ],

    popularAreas: [
      "town-centre",
      "fortress-area",
      "cape-saint-vincent",
    ],

    hotels: [
      "memmo-baleeira",
      "pousada-de-sagres",
      "martinhal-sagres",
    ],

    beaches: [
      "mareta-beach",
      "beliche-beach",
      "tonel-beach",
    ],
  },

  seville: {
    id: "seville",
    type: "city",

    nearbyLocationIds: [
      "huelva",
      "ayamonte",
      "faro",
      "faro-airport",
      "albufeira",
    ],

    highlights: [
      "seville-cathedral",
      "real-alcazar",
      "plaza-de-espana",
      "santa-cruz",
    ],

    popularAreas: [
      "historic-centre",
      "santa-cruz",
      "triana",
      "seville-airport",
    ],

    hotels: [
      "hotel-alfonso-xiii",
      "melia-sevilla",
      "eurostars-torre-sevilla",
    ],

    beaches: [],
  },

  lisbon: {
    id: "lisbon",
    type: "city",

    nearbyLocationIds: [
      "lisbon-airport",
      "cascais",
      "sintra",
      "setubal",
      "faro",
    ],

    highlights: [
      "belem-tower",
      "alfama",
      "baixa",
      "jeronimos-monastery",
    ],

    popularAreas: [
      "baixa",
      "chiado",
      "alfama",
      "belem",
      "parque-das-nacoes",
    ],

    hotels: [
      "four-seasons-hotel-ritz-lisbon",
      "corinthia-lisbon",
      "pestana-palace",
    ],

    beaches: [],
  },
};